import { kiwiGreen, spaceCadet } from '@cogneed/react-utils';
import { Dialog, styled } from '@mui/material';

const StyledDialog = styled(Dialog)({
  '& .MuiDialog-container': {
    minHeight: 400,
    maxHeight: 1080,
  },
  '& .MuiDialogTitle-root': {
    fontWeight: 'bold',
  },
  '& .MuiDialogActions-root': {
    justifyContent: 'space-between',
    padding: '8px 24px',
  },
  '& .MuiDialogContentText-root': {
    fontSize: 14,
    color: spaceCadet[800],
    marginBottom: 16,
  },
  '& .MuiButton-root.forget': {
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },
  '& .MuiTypography-root.sso-success': {
    color: kiwiGreen[600],
    backgroundColor: kiwiGreen[100],
    borderRadius: 4,
    padding: 8,
    fontSize: 14,
    marginTop: 16,
  },
});
export default StyledDialog;
